<script>
	import { t } from '$lib/locales';
	import ErrorIcon from './ErrorIcon.svelte';
	import GbmInput from './GbmInput.svelte';

	export let error;

	const refresh = () => {
		window.location.reload();
	};
</script>

<div>
	<ErrorIcon />
	<p class="main-error">
		{error.statusCode ? error.statusCode + '\n' : ''}
		{$t('gbm.error.api')}
	</p>
	<GbmInput type="button" on:click={refresh}>
		<p>{$t('shared.refresh')}</p>
	</GbmInput>
</div>

<style>
	div {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 30px;
		padding: 20px;
	}
	p {
		color: var(--font-color);
		text-align: center;
		margin: 0;
		white-space: pre-wrap;
	}
</style>
